(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9264],{

/***/ 95573:
/***/ (function(module) {

"use strict";
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */



/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Module exports.
 * @public
 */

module.exports = escapeHtml;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&quot;';
        break;
      case 38: // &
        escape = '&amp;';
        break;
      case 39: // '
        escape = '&#39;';
        break;
      case 60: // <
        escape = '&lt;';
        break;
      case 62: // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index
    ? html + str.substring(lastIndex, index)
    : html;
}


/***/ }),

/***/ 79933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ PartnersBanners; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46670);
/* harmony import */ var _PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34268);
/* harmony import */ var _PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _hooks_useEmblaSlider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21471);
/* harmony import */ var _Dots__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63002);
/* harmony import */ var _GalleryModal_components_Arrows_Arrows__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86318);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27101);
/* harmony import */ var _Skeleton_SkeletonCover__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9792);
/* harmony import */ var _Image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49028);






// import { desktopBanners, mobBanners } from './arraysPartnersBanners';




var PartnersBanners = (0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_2__/* .observer */ .Pi)(function(param) {
    var isMobile = param.isMobile, isTablet = param.isTablet, isLandingPage = param.isLandingPage, banners = param.banners;
    var mainResult = (0,_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_6__/* .useSearchStore */ .Rp)().mainResult;
    var firstLoading = mainResult.isFirstLoading;
    // const partnerBanner = isMobile ? mobBanners : desktopBanners;
    var partnerBanner = banners;
    var ReworkImageUrl = function(url) {
        if (isMobile) {
            return "https://kruiz.online/images/main_page/banners/mobile/".concat(url);
        }
        if (isTablet) {
            return "https://kruiz.online/images/main_page/banners/desktop/".concat(url);
        }
        return "https://kruiz.online/images/main_page/banners/desktop/".concat(url);
    };
    var ref = (0,_hooks_useEmblaSlider__WEBPACK_IMPORTED_MODULE_3__/* .useEmblaSlider */ .r)({
        loop: true
    }, false), ref1 = ref.ref, current = ref.current, onSelectSlide = ref.onSelectSlide, scrollPrev = ref.scrollPrev, scrollNext = ref.scrollNext, prevBtnEnabled = ref.prevBtnEnabled, nextBtnEnabled = ref.nextBtnEnabled;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var interval = setInterval(function() {
            scrollNext();
        }, 4000); // Меняем слайд каждые 4 секунды
        return function() {
            return clearInterval(interval);
        };
    }, [
        scrollNext
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: isMobile ? (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().partnerBannerMob) : (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().partnersBanner),
        children: firstLoading && !isLandingPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton_SkeletonCover__WEBPACK_IMPORTED_MODULE_7__/* .SkeletonCover */ .B, {
            width: 1100,
            height: 220
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().embla),
            ref: ref1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().emblaContainer),
                    children: partnerBanner === null || partnerBanner === void 0 ? void 0 : partnerBanner.map(function(i, key) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().emblaSlide),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: i === null || i === void 0 ? void 0 : i.page_url,
                                z: true,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image_Image__WEBPACK_IMPORTED_MODULE_8__/* .Image */ .E, {
                                        src: ReworkImageUrl(i.src),
                                        srcSet: ReworkImageUrl(i.srcset)
                                    }),
                                    i === null || i === void 0 ? void 0 : i.imgBanner
                                ]
                            }, key)
                        }, key);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GalleryModal_components_Arrows_Arrows__WEBPACK_IMPORTED_MODULE_5__/* .PrevArrow */ .$B, {
                    onClick: scrollPrev,
                    enabled: prevBtnEnabled
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GalleryModal_components_Arrows_Arrows__WEBPACK_IMPORTED_MODULE_5__/* .NextArrow */ .gV, {
                    onClick: scrollNext,
                    enabled: nextBtnEnabled
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dots__WEBPACK_IMPORTED_MODULE_4__/* .Dots */ .b, {
                    view: "longDots",
                    spaceBetween: 6,
                    count: partnerBanner === null || partnerBanner === void 0 ? void 0 : partnerBanner.length,
                    topGap: 12,
                    active: current,
                    onSelect: onSelectSlide
                })
            ]
        })
    });
});


/***/ }),

/***/ 28692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ BlogMainPage; },
  "o": function() { return /* reexport */ BlogPostPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(46670);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/BlogPage/blogMainPage.module.sass
var blogMainPage_module = __webpack_require__(81036);
var blogMainPage_module_default = /*#__PURE__*/__webpack_require__.n(blogMainPage_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/RadioButton/index.js + 1 modules
var RadioButton = __webpack_require__(71543);
// EXTERNAL MODULE: ./components/CardNews/index.js + 1 modules
var CardNews = __webpack_require__(39133);
// EXTERNAL MODULE: ./components/Banner/PartnersBanner/PartnersBanners.jsx
var PartnersBanners = __webpack_require__(79933);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(24561);
// EXTERNAL MODULE: ./components/Skeleton/Skeleton.module.sass
var Skeleton_module = __webpack_require__(36701);
var Skeleton_module_default = /*#__PURE__*/__webpack_require__.n(Skeleton_module);
;// CONCATENATED MODULE: ./components/Skeleton/SkeletonNewsCard.jsx







var SkeletonNewsCard = function(_param) /*#__PURE__*/ {
    var animate = _param.animate, props = (0,_object_without_properties/* default */.Z)(_param, [
        "animate"
    ]);
    return (0,jsx_runtime.jsx)("div", {
        className: (Skeleton_module_default()).card,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_content_loader_es/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            speed: 1,
            width: 400,
            animate: animate,
            viewBox: "0 0 356 403",
            backgroundColor: "#F3F6F9",
            foregroundColor: "#F9F9F9",
            style: {
                maxWidth: "100%",
                minWidth: "100%"
            }
        }, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "0",
                    rx: "0",
                    ry: "0",
                    width: "356",
                    height: "172"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "16",
                    y: "188",
                    rx: "0",
                    ry: "0",
                    width: "328",
                    height: "60"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "16",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "285",
                    height: "20"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "16",
                    y: "284",
                    rx: "0",
                    ry: "0",
                    width: "245",
                    height: "20"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "16",
                    y: "312",
                    rx: "0",
                    ry: "0",
                    width: "205",
                    height: "20"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "16",
                    y: "460",
                    rx: "0",
                    ry: "0",
                    width: "342",
                    height: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "16",
                    y: "493",
                    rx: "0",
                    ry: "0",
                    width: "125",
                    height: "24"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "174",
                    y: "476",
                    rx: "4",
                    ry: "4",
                    width: "170",
                    height: "56"
                })
            ]
        }))
    });
};

// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
;// CONCATENATED MODULE: ./components/BlogPage/BlogMainPage.jsx
















var BlogMainPage = (0,es/* observer */.Pi)(function(param) {
    var isMobile = param.isMobile, isTablet = param.isTablet, banners = param.banners;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var store = (0,RootStoreProvider/* useBlogStore */.Ny)();
    var isLoading = store.loading;
    var router = (0,next_router.useRouter)();
    var allMedia = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)([
            {
                id: "all",
                label: "Все"
            }, 
        ]).concat((0,_to_consumable_array/* default */.Z)(store.data.media_list.map(function(param) {
            var id = param.id, label = param.label;
            return {
                id: String(id),
                label: label
            };
        })));
    }, [
        store.data.media_list
    ]);
    var onShowMore = function() {
        store.loadMorePosts({
            page: store.page + 1,
            media: store.media
        });
    };
    var ref13, ref14, ref15, ref16, ref17, ref18;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (blogMainPage_module_default()).contact,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    component: "h1",
                    variant: "heading-lg",
                    bottomGap: 24,
                    children: "Полезные советы и статьи о круизах"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (blogMainPage_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        initialValues: {
                            blogNewsType: "1"
                        },
                        children: function() {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                                className: (blogMainPage_module_default()).form,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* RadioButton */.E, {
                                    options: (ref13 = allMedia === null || allMedia === void 0 ? void 0 : allMedia.map(function(param) {
                                        var id = param.id, label = param.label;
                                        return {
                                            value: id,
                                            label: label
                                        };
                                    })) !== null && ref13 !== void 0 ? ref13 : [],
                                    name: "blogNewsType",
                                    filter: true,
                                    actionOnClick: function(e) {
                                        router.replace({
                                            query: {
                                                media: e
                                            }
                                        }, undefined, {
                                            shallow: true
                                        });
                                        store.loadPosts({
                                            page: 1,
                                            media: e
                                        });
                                    },
                                    values: (ref14 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.media) !== null && ref14 !== void 0 ? ref14 : "all"
                                })
                            });
                        }
                    }),
                    !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !((ref = store.data) === null || ref === void 0 ? void 0 : (ref1 = ref.posts_list) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean).length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (blogMainPage_module_default()).notFound,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        width: 48,
                                        height: 48,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                            name: "emoji/sadFace",
                                            width: 48,
                                            height: 48
                                        }),
                                        title: "Грусть, тоска"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        component: "h3",
                                        variant: "heading-2",
                                        bottomGap: 24,
                                        topGap: 16,
                                        children: "Посты не найдены :("
                                    })
                                ]
                            }),
                            ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.media) === "all" || !router.query.media ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (blogMainPage_module_default()).firstGrid,
                                children: ((ref15 = (ref3 = store.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.posts_list) === null || ref4 === void 0 ? void 0 : ref4.filter(Boolean)) !== null && ref15 !== void 0 ? ref15 : []).slice(0, 5).map(function(i, key) {
                                    return key === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNews/* CardNews */.v, {
                                        array: i,
                                        link: "/blog/".concat(i === null || i === void 0 ? void 0 : i.link),
                                        size: "xl",
                                        isMobile: isMobile
                                    }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNews/* CardNews */.v, {
                                        array: i,
                                        link: "/blog/".concat(i === null || i === void 0 ? void 0 : i.link),
                                        isMobile: isMobile
                                    }, key);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (blogMainPage_module_default()).secondGrid,
                                children: ((ref16 = (ref5 = store.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.posts_list) === null || ref6 === void 0 ? void 0 : ref6.filter(Boolean)) !== null && ref16 !== void 0 ? ref16 : []).slice(0, 4).map(function(i, key) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CardNews/* CardNews */.v, {
                                        array: i,
                                        link: "/blog/".concat(i === null || i === void 0 ? void 0 : i.link),
                                        isMobile: isMobile
                                    }, key);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersBanners/* PartnersBanners */.v, {
                                isMobile: isMobile,
                                isTablet: isTablet,
                                banners: banners
                            }),
                            ((ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.media) === "all" || !router.query.media ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (blogMainPage_module_default()).secondGrid,
                                children: ((ref17 = (ref8 = store.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.posts_list) === null || ref9 === void 0 ? void 0 : ref9.filter(Boolean)) !== null && ref17 !== void 0 ? ref17 : []).slice(5).map(function(i, key) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CardNews/* CardNews */.v, {
                                        array: i,
                                        link: "/blog/".concat(i === null || i === void 0 ? void 0 : i.link),
                                        isMobile: isMobile
                                    }, key);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (blogMainPage_module_default()).secondGrid,
                                children: ((ref18 = (ref10 = store.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.posts_list) === null || ref11 === void 0 ? void 0 : ref11.filter(Boolean)) !== null && ref18 !== void 0 ? ref18 : []).slice(4).map(function(i, key) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CardNews/* CardNews */.v, {
                                        array: i,
                                        link: "/blog/".concat(i === null || i === void 0 ? void 0 : i.link),
                                        isMobile: isMobile
                                    }, key);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (blogMainPage_module_default()).button,
                                children: ((ref12 = store.data) === null || ref12 === void 0 ? void 0 : ref12.total_pages) > store.page && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    view: "textResult",
                                    size: "very-large",
                                    onClick: onShowMore,
                                    className: (blogMainPage_module_default()).buttonWrapper,
                                    children: "Показать еще"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (blogMainPage_module_default()).secondGrid,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonNewsCard, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonNewsCard, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonNewsCard, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonNewsCard, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonNewsCard, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonNewsCard, {})
                        ]
                    })
                ]
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/BlogPage/BlogPostPage/blogPostPage.module.sass
var blogPostPage_module = __webpack_require__(16836);
var blogPostPage_module_default = /*#__PURE__*/__webpack_require__.n(blogPostPage_module);
// EXTERNAL MODULE: ./components/Image/Image.jsx
var Image = __webpack_require__(49028);
// EXTERNAL MODULE: ./utils/resolveUrl.js
var resolveUrl = __webpack_require__(95773);
// EXTERNAL MODULE: ./utils/serialize.jsx
var serialize = __webpack_require__(27777);
;// CONCATENATED MODULE: ./components/BlogPage/BlogPostPage/BlogPostPage.jsx













var BlogPostPage = (0,es/* observer */.Pi)(function(param) {
    var isMobile = param.isMobile, isTablet = param.isTablet, banners = param.banners;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var store = (0,RootStoreProvider/* useBlogStore */.Ny)();
    var article = store.article;
    var _body;
    var partTwo = (0,_to_consumable_array/* default */.Z)((_body = article.body) !== null && _body !== void 0 ? _body : []);
    var i = 0;
    var banner = 0;
    partTwo.forEach(function(param, index) {
        var type = param.type;
        if (type === "heading-two" && i < 4) {
            i++;
            banner = index;
        }
    });
    var partOne = i === 4 ? partTwo.splice(0, banner) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (blogPostPage_module_default()).container,
        itemScope: true,
        itemType: "http://schema.org/BlogPosting",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (blogPostPage_module_default()).head,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        className: (blogPostPage_module_default()).mainTitle,
                        component: "h1",
                        variant: "heading-lg",
                        itemProp: "headline",
                        children: article === null || article === void 0 ? void 0 : article.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (blogPostPage_module_default()).mainImage,
                        itemScope: true,
                        itemType: "http://schema.org/ImageObject",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                src: "".concat((0,resolveUrl/* resolveUrl */.K)(article === null || article === void 0 ? void 0 : (ref = article.photo) === null || ref === void 0 ? void 0 : ref.src)),
                                srcSet: "".concat((0,resolveUrl/* resolveUrl */.K)(article === null || article === void 0 ? void 0 : (ref1 = article.photo) === null || ref1 === void 0 ? void 0 : ref1.srcset)),
                                alt: article === null || article === void 0 ? void 0 : (ref2 = article.photo) === null || ref2 === void 0 ? void 0 : ref2.alt,
                                loading: "lazy",
                                itemProp: "image",
                                title: article === null || article === void 0 ? void 0 : (ref3 = article.photo) === null || ref3 === void 0 ? void 0 : ref3.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "url",
                                content: (0,resolveUrl/* resolveUrl */.K)((ref4 = store.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.photo) === null || ref5 === void 0 ? void 0 : ref5.src)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (blogPostPage_module_default()).info,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (blogPostPage_module_default()).date,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/blog?media=".concat(article === null || article === void 0 ? void 0 : article.media.id),
                                        variant: "linkAsButtonPrimary",
                                        itemProp: "keywords",
                                        children: article === null || article === void 0 ? void 0 : article.media.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        component: "div",
                                        variant: "text-1",
                                        itemProp: "datePublished",
                                        children: article === null || article === void 0 ? void 0 : article.date
                                    })
                                ]
                            }),
                            !!article.reading_time && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (blogPostPage_module_default()).readTime,
                                itemProp: "timeRequired",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        width: 16,
                                        height: 16,
                                        rightGap: 4,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                            name: "common/time",
                                            width: 16,
                                            height: 16
                                        }),
                                        title: "Время чтения статьи"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                        component: "div",
                                        variant: "text-1",
                                        color: "subColor",
                                        children: [
                                            article.reading_time,
                                            " мин. на чтение"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (blogPostPage_module_default()).article,
                itemProp: "articleBody",
                children: [
                    (0,serialize/* serialize */.q)(partOne),
                    !!partOne.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (blogPostPage_module_default()).banner,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersBanners/* PartnersBanners */.v, {
                            isMobile: isMobile,
                            isTablet: isTablet,
                            banners: banners
                        })
                    }),
                    (0,serialize/* serialize */.q)(partTwo),
                    !partOne.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (blogPostPage_module_default()).banner,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersBanners/* PartnersBanners */.v, {
                            isMobile: isMobile,
                            isTablet: isTablet,
                            banners: banners
                        })
                    })
                ]
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/BlogPage/index.js




/***/ }),

/***/ 24277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/BreadCrumbs/breadCrumbs.module.sass
var breadCrumbs_module = __webpack_require__(75685);
var breadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadCrumbs_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/BreadCrumbs/BreadCrumbs.jsx







var BreadCrumbs = function(param) {
    var routeCrumbs = param.routeCrumbs, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadCrumbs_module_default()).wrapper,
        itemScope: true,
        itemType: "https://schema.org/BreadcrumbList",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (breadCrumbs_module_default()).overflowWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (breadCrumbs_module_default()).crumb,
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        itemProp: "name",
                        className: (0,classcat/* default */.Z)([
                            (breadCrumbs_module_default()).home,
                            (0,_define_property/* default */.Z)({}, (breadCrumbs_module_default()).homeBf, url === "black_friday"), 
                        ]),
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/bfHomePage",
                                width: 10,
                                height: 10
                            }),
                            itemProp: "item"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/HomePage",
                                width: 16,
                                height: 16
                            }),
                            itemProp: "item"
                        })
                    })
                }),
                routeCrumbs.map(function(i, id) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: "https://schema.org/ListItem",
                        className: (breadCrumbs_module_default()).point,
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).currentBf : (breadCrumbs_module_default()).activeBf,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).current : (breadCrumbs_module_default()).active,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        })
                    }, id);
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/BreadCrumbs/index.js



/***/ }),

/***/ 39133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ CardNews; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/CardNews/CardNews.module.sass
var CardNews_module = __webpack_require__(27404);
var CardNews_module_default = /*#__PURE__*/__webpack_require__.n(CardNews_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/Image/Image.jsx
var Image = __webpack_require__(49028);
// EXTERNAL MODULE: ./utils/resolveUrl.js
var resolveUrl = __webpack_require__(95773);
;// CONCATENATED MODULE: ./components/CardNews/CardNews.jsx






// import { resolveUrl } from '../../utils/resolveUrl';
// import {ReworkUrl} from "../../utils/reworkUrl";


var CardNews = function(param) {
    var array = param.array, _size = param.size, size = _size === void 0 ? "sm" : _size, link = param.link, isMobile = param.isMobile, isMedia = param.isMedia;
    var ref, ref1, ref2, ref3, ref4;
    var minutesEnd = function(minutes) {
        if (minutes % 10 === 1 && minutes % 100 !== 11) {
            return "".concat(minutes, " минута");
        }
        if ([
            2,
            3,
            4
        ].includes(minutes % 10) && ![
            12,
            13,
            14
        ].includes(minutes % 100)) {
            return "".concat(minutes, " минуты");
        }
        return "".concat(minutes, " минут");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            itemScope: true,
            itemType: "http://schema.org/Article",
            className: (0,classcat/* default */.Z)([
                (CardNews_module_default()).card,
                // [styles.small]: size === 'sm',
                // [styles.medium]: size === 'md',
                (0,_define_property/* default */.Z)({}, (CardNews_module_default()).large, size === "xl"), 
            ]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Anchor */.e, {
                href: link || (array === null || array === void 0 ? void 0 : array.link),
                className: (CardNews_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardNews_module_default()).linkPhoto,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: "".concat((0,resolveUrl/* resolveUrl */.K)((array === null || array === void 0 ? void 0 : (ref = array.photo) === null || ref === void 0 ? void 0 : ref.src) || (array === null || array === void 0 ? void 0 : array.photo))),
                            srcSet: "".concat((0,resolveUrl/* resolveUrl */.K)((array === null || array === void 0 ? void 0 : (ref1 = array.photo) === null || ref1 === void 0 ? void 0 : ref1.srcSet) || (array === null || array === void 0 ? void 0 : array.photo))),
                            alt: String(array === null || array === void 0 ? void 0 : (ref2 = array.photo) === null || ref2 === void 0 ? void 0 : ref2.alt),
                            title: String(array === null || array === void 0 ? void 0 : (ref3 = array.photo) === null || ref3 === void 0 ? void 0 : ref3.title),
                            loading: "lazy",
                            itemProp: "image"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CardNews_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CardNews_module_default()).info,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        variant: "timeTable",
                                        weiht: "700",
                                        href: "/blog?media=".concat(array === null || array === void 0 ? void 0 : array.media.id),
                                        itemProp: "publisher",
                                        children: array === null || array === void 0 ? void 0 : (ref4 = array.media) === null || ref4 === void 0 ? void 0 : ref4.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        // className={styles.date}
                                        className: isMedia ? (CardNews_module_default()).mediaDate : (CardNews_module_default()).date,
                                        component: "p",
                                        variant: "text-1",
                                        itemProp: "datePublished",
                                        children: array === null || array === void 0 ? void 0 : array.date
                                    }),
                                    !!array.reading_time && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CardNews_module_default()).readTime,
                                        itemProp: "timeRequired",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            component: "div",
                                            variant: "text-1",
                                            color: "subColor",
                                            children: minutesEnd(array.reading_time)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CardNews_module_default()).description,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        component: "h2",
                                        variant: size === "xl" && !isMobile ? "heading-2" : "heading-6",
                                        itemProp: "headline",
                                        topGap: 16,
                                        bottomGap: 12,
                                        children: array === null || array === void 0 ? void 0 : array.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        className: (CardNews_module_default()).text,
                                        component: "p",
                                        variant: "text-1",
                                        itemProp: "description",
                                        children: array === null || array === void 0 ? void 0 : array.description
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/CardNews/index.js



/***/ }),

/***/ 63002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ Dots; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/Dots/dots.module.sass
var dots_module = __webpack_require__(55828);
var dots_module_default = /*#__PURE__*/__webpack_require__.n(dots_module);
// EXTERNAL MODULE: ./utils/isClient.js
var isClient = __webpack_require__(69594);
;// CONCATENATED MODULE: ./components/Dots/Dots.jsx






var Dots = function(param) {
    var view = param.view, count = param.count, active = param.active, onSelect = param.onSelect, spaceBetween = param.spaceBetween, topGap = param.topGap;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classcat/* default */.Z)([
            (dots_module_default()).dots,
            (dots_module_default())[view]
        ]),
        style: {
            paddingTop: "".concat(topGap, " px")
        },
        children: isClient/* isClient */.C && new Array(count).fill(0).map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Select",
                style: {
                    margin: "0 ".concat(spaceBetween, "px")
                },
                onClick: function() {
                    if (onSelect) onSelect(index);
                },
                className: (0,classcat/* default */.Z)((0,_define_property/* default */.Z)({}, (dots_module_default()).active, active === index))
            }, index);
        })
    });
};
Dots.defaultProps = {
    view: "regularDots",
    spaceBetween: 4,
    topGap: 16,
    onSelect: null
};

;// CONCATENATED MODULE: ./components/Dots/index.js



/***/ }),

/***/ 86318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ PrevArrow; },
/* harmony export */   "Ci": function() { return /* binding */ PrevThumbArrow; },
/* harmony export */   "gV": function() { return /* binding */ NextArrow; },
/* harmony export */   "s6": function() { return /* binding */ NextThumbArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classcat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83840);
/* harmony import */ var _arrows_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99407);
/* harmony import */ var _arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85708);
/* harmony import */ var _SpriteSVG__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2708);






var PrevArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonPrev)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-arrow",
                width: 16,
                height: 29
            })
        })
    });
};
var NextArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonNext)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-arrow",
                width: 16,
                height: 29,
                alt: "К следующему"
            }),
            title: "К следующему"
        })
    });
};
var PrevThumbArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonPrev)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            className: (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().lg),
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-thumb-arrow",
                width: 9,
                height: 17,
                alt: "К следующему"
            }),
            title: "К следующему"
        })
    });
};
var NextThumbArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonNext)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            className: (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().lg),
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-thumb-arrow",
                width: 9,
                height: 17,
                alt: "К следующему"
            }),
            title: "К следующему"
        })
    });
};


/***/ }),

/***/ 49028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classcat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83840);
/* harmony import */ var _image_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52851);
/* harmony import */ var _image_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_image_module_sass__WEBPACK_IMPORTED_MODULE_5__);






var Image = function(_param) /*#__PURE__*/ {
    var src = _param.src, srcSet = _param.srcSet, alt = _param.alt, width = _param.width, height = _param.height, size = _param.size, _media = _param.media, media = _media === void 0 ? "500px" : _media, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "src",
        "srcSet",
        "alt",
        "width",
        "height",
        "size",
        "media"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        children: [
            srcSet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: "".concat(srcSet),
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                src: "".concat(src),
                alt: alt,
                className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
                    (_image_module_sass__WEBPACK_IMPORTED_MODULE_5___default().root),
                    (_image_module_sass__WEBPACK_IMPORTED_MODULE_5___default())[size]
                ]),
                width: size ? "100%" : "".concat(width, "px"),
                height: size ? "100%" : "".concat(height, "px")
            }, props))
        ]
    });
};
Image.defaultProps = {
    src: "",
    srcSet: "",
    alt: "",
    width: 300,
    height: 300,
    size: "cover"
};


/***/ }),

/***/ 71543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ RadioButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./components/RadioButton/radioButton.module.sass
var radioButton_module = __webpack_require__(51055);
var radioButton_module_default = /*#__PURE__*/__webpack_require__.n(radioButton_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
;// CONCATENATED MODULE: ./components/RadioButton/RadioButton.jsx









var RadioButton = function(param) {
    var options = param.options, name = param.name, values = param.values, short = param.short, filter = param.filter, actionOnClick = param.actionOnClick, isPaidStep = param.isPaidStep;
    var ref, ref1;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: (radioButton_module_default()).radioGroup,
        children: [
            !isPaidStep ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classcat/* default */.Z)([
                    (0,_define_property/* default */.Z)({}, (radioButton_module_default()).radioGroupShort, short),
                    (0,_define_property/* default */.Z)({}, (radioButton_module_default()).radioGroupFilter, filter), 
                ]),
                children: options === null || options === void 0 ? void 0 : options.map(function(option) {
                    var _obj;
                    return (option === null || option === void 0 ? void 0 : option.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,classcat/* default */.Z)([
                                        (radioButton_module_default()).radioButton,
                                        (_obj = {}, (0,_define_property/* default */.Z)(_obj, (radioButton_module_default()).radioButtonChecked, values === option.value), (0,_define_property/* default */.Z)(_obj, (radioButton_module_default()).radioButtonFilter, filter), _obj), 
                                    ]),
                                    children: [
                                        option.gift && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (radioButton_module_default()).gift,
                                            children: "+ подарок"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    className: (radioButton_module_default()).input,
                                                    type: "radio",
                                                    name: name,
                                                    value: option.value,
                                                    onClick: function() {
                                                        if (actionOnClick) {
                                                            actionOnClick(option.value);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (radioButton_module_default()).inputWrapper,
                                                    children: [
                                                        option.img ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/icons/paySberpay.svg",
                                                            alt: "Способ оплаты"
                                                        }) : option.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                                name: option.icon,
                                                                width: option.iconWidth,
                                                                height: option.iconHeight
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (radioButton_module_default()).inputBlock,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                        variant: "text",
                                                                        children: option.label
                                                                    })
                                                                }),
                                                                option.labelTag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (radioButton_module_default()).labelTag,
                                                                    children: option.labelTag
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                        variant: "text-3",
                                                                        children: option.subLabel
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                values === option.value && !short && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (radioButton_module_default()).radioButtonDescription,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        variant: "text",
                                        color: "darkenColor",
                                        children: option.description
                                    })
                                })
                            ]
                        })
                    });
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classcat/* default */.Z)([
                    (0,_define_property/* default */.Z)({}, (radioButton_module_default()).radioGroupShort, short),
                    (0,_define_property/* default */.Z)({}, (radioButton_module_default()).radioGroupFilter, filter), 
                ]),
                children: (ref = options.slice(0, 2)) === null || ref === void 0 ? void 0 : ref.map(function(option) {
                    var _obj;
                    return (option === null || option === void 0 ? void 0 : option.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,classcat/* default */.Z)([
                                        (radioButton_module_default()).radioButton,
                                        (_obj = {}, (0,_define_property/* default */.Z)(_obj, (radioButton_module_default()).radioButtonChecked, values === option.value), (0,_define_property/* default */.Z)(_obj, (radioButton_module_default()).radioButtonFilter, filter), _obj), 
                                    ]),
                                    children: [
                                        option.gift && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (radioButton_module_default()).gift,
                                            children: "+ подарок"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    className: (radioButton_module_default()).input,
                                                    type: "radio",
                                                    name: name,
                                                    value: option.value,
                                                    onClick: function() {
                                                        if (actionOnClick) {
                                                            actionOnClick(option.value);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (radioButton_module_default()).inputWrapper,
                                                    children: [
                                                        option.img ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/icons/paySberpay.svg",
                                                            alt: "Способ оплаты"
                                                        }) : option.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                                name: option.icon,
                                                                width: option.iconWidth,
                                                                height: option.iconHeight
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (radioButton_module_default()).inputBlock,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                        variant: "text",
                                                                        children: option.label
                                                                    })
                                                                }),
                                                                option.labelTag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (radioButton_module_default()).labelTag,
                                                                    children: option.labelTag
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                        variant: "text-3",
                                                                        children: option.subLabel
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                values === option.value && !short && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (radioButton_module_default()).radioButtonDescription,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        variant: "text",
                                        color: "darkenColor",
                                        children: option.description
                                    })
                                })
                            ]
                        })
                    });
                })
            }),
            isPaidStep && ((ref1 = options.slice(2)) === null || ref1 === void 0 ? void 0 : ref1.map(function(option, index) {
                var _obj;
                return (option === null || option === void 0 ? void 0 : option.value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                margin: "16px 0 16px"
                            },
                            className: (0,classcat/* default */.Z)([
                                (radioButton_module_default()).radioButton,
                                (_obj = {}, (0,_define_property/* default */.Z)(_obj, (radioButton_module_default()).radioButtonChecked, values === option.value), (0,_define_property/* default */.Z)(_obj, (radioButton_module_default()).radioButtonFilter, filter), _obj), 
                            ]),
                            children: [
                                option.gift && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (radioButton_module_default()).gift,
                                    children: "+ подарок"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                    className: (radioButton_module_default()).input,
                                    type: "radio",
                                    name: name,
                                    value: option.value,
                                    onClick: function() {
                                        if (actionOnClick) {
                                            actionOnClick(option.value);
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (radioButton_module_default()).inputWrapper,
                                    children: [
                                        option.img ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/icons/paySberpay.svg",
                                            alt: "Способ оплаты"
                                        }) : option.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                name: option.icon,
                                                width: option.iconWidth,
                                                height: option.iconHeight
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (radioButton_module_default()).inputBlock,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    variant: "text",
                                                    children: option.label
                                                }),
                                                option.labelTag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (radioButton_module_default()).labelTag,
                                                    children: option.labelTag
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    variant: "text-3",
                                                    children: option.subLabel
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        values === option.value && !short && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (radioButton_module_default()).radioButtonDescription,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                variant: "text",
                                color: "darkenColor",
                                children: option.description
                            })
                        })
                    ]
                }, "".concat(option.value, "-extra-").concat(index));
            })),
            short && options.map(function(dis) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: values === dis.value && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (radioButton_module_default()).radioButtonDescription,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            variant: "text",
                            color: "darkenColor",
                            children: dis.description
                        })
                    })
                });
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/RadioButton/index.js



/***/ }),

/***/ 21471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useEmblaSlider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25585);
/* harmony import */ var embla_carousel_autoplay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22074);




var useEmblaSlider = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        loop: false,
        skipSnaps: false
    }, isAutoplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var autoplay = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)((0,embla_carousel_autoplay__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        delay: 5000
    }, function(emblaRoot) {
        return emblaRoot.parentElement;
    }));
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), current = ref[0], setCurrent = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(options, isAutoplay ? [
        autoplay.current
    ] : undefined), 2), ref2 = ref1[0], embla = ref1[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), prevBtnEnabled = ref3[0], setPrevBtnEnabled = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), nextBtnEnabled = ref4[0], setNextBtnEnabled = ref4[1];
    var scrollPrev = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return embla && embla.scrollPrev();
    }, [
        embla
    ]);
    var scrollNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return embla && embla.scrollNext();
    }, [
        embla
    ]);
    var onSelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (!embla) return;
        setCurrent(embla.selectedScrollSnap());
        setPrevBtnEnabled(embla.canScrollPrev());
        setNextBtnEnabled(embla.canScrollNext());
    }, [
        embla,
        current
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!embla) return;
        onSelect();
        embla.on("select", onSelect);
    }, [
        embla,
        onSelect
    ]);
    var onSelectSlide = function(index) {
        embla.scrollTo(index);
    };
    return {
        ref: ref2,
        current: current,
        onSelectSlide: onSelectSlide,
        scrollPrev: scrollPrev,
        scrollNext: scrollNext,
        prevBtnEnabled: prevBtnEnabled,
        nextBtnEnabled: nextBtnEnabled
    };
};


/***/ }),

/***/ 95773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ resolveUrl; }
/* harmony export */ });
var resolveUrl = function(url) {
    return  false ? 0 : url;
};


/***/ }),

/***/ 27777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ serialize; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var slate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77493);
/* harmony import */ var escape_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95573);
/* harmony import */ var escape_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(escape_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49028);





var serialize = function(children) {
    return children === null || children === void 0 ? void 0 : children.map(function(node, i) {
        if (node.type === "numbered-list") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                children: serialize(node.children)
            }, i);
        }
        if (slate__WEBPACK_IMPORTED_MODULE_4__/* .Text.isText */ .xv.isText(node)) {
            var text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.text)
                }
            });
            if (node.bold) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: text
                }, i);
            }
            if (node.code) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                    children: text
                }, i);
            }
            if (node.italic) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                    children: text
                }, i);
            }
            if (node.underline) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        textDecoration: "underline"
                    },
                    children: text
                }, i);
            }
            if (node.strikethrough) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        textDecoration: "line-through"
                    },
                    children: text
                }, i);
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: text
            }, i);
        }
        if (!node) {
            return null;
        }
        switch(node.type){
            case "h1":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: serialize(node.children)
                }, i);
            case "h2":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: serialize(node.children)
                }, i);
            case "h3":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    children: serialize(node.children)
                }, i);
            case "h4":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    children: serialize(node.children)
                }, i);
            case "h5":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    children: serialize(node.children)
                }, i);
            case "h6":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                    children: serialize(node.children)
                }, i);
            case "blockquote":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                    children: serialize(node.children)
                }, i);
            case "ul":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: serialize(node.children)
                }, i);
            case "ol":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    children: serialize(node.children)
                }, i);
            case "li":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: serialize(node.children)
                }, i);
            case "list-item":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: serialize(node.children)
                }, i);
            case "heading-one":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: serialize(node.children)
                }, i);
            case "heading-two":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: serialize(node.children)
                }, i);
            case "link":
                if (node.url.includes("youtube.com") || node.url.includes("https://vk.com/video")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: "420px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                            width: "100%",
                            title: "YouTube video player",
                            src: node.url,
                            allowFullScreen: true,
                            allow: "accelerometer",
                            referrerPolicy: "strict-origin-when-cross-origin"
                        })
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    rel: "noopener noreferrer",
                    style: {
                        color: "blue"
                    },
                    children: serialize(node.children)
                }, i);
            case "image":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image_Image__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
                    src: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    srcSet: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    alt: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.alt),
                    title: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.title),
                    loading: "lazy",
                    itemProp: "image"
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: serialize(node.children)
                }, i);
        }
    });
};


/***/ }),

/***/ 34268:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"partnersBanner":"PartnersBanner_partnersBanner__wZxqB","partnerBannerMob":"PartnersBanner_partnerBannerMob__ynzMN","banner":"PartnersBanner_banner__eVrCq","embla":"PartnersBanner_embla__61Wmt","emblaContainer":"PartnersBanner_emblaContainer__UfIUx","emblaSlide":"PartnersBanner_emblaSlide__Kde3E"};

/***/ }),

/***/ 16836:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"blogPostPage_container__UbK_X","head":"blogPostPage_head__ox9yd","mainTitle":"blogPostPage_mainTitle__0FV3Z","mainImage":"blogPostPage_mainImage__w7NHd","info":"blogPostPage_info__K51lw","date":"blogPostPage_date__mLhVO","readTime":"blogPostPage_readTime__9fH4E","article":"blogPostPage_article__pyF_8","banner":"blogPostPage_banner__1HBVD"};

/***/ }),

/***/ 81036:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"blogMainPage_form__6Ry_a","firstGrid":"blogMainPage_firstGrid__0DiD_","secondGrid":"blogMainPage_secondGrid__N5okq","button":"blogMainPage_button__Kp68O","buttonWrapper":"blogMainPage_buttonWrapper__x_rP8","notFound":"blogMainPage_notFound__Wxs7m"};

/***/ }),

/***/ 75685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadCrumbs_wrapper__GujyW","overflowWrapper":"breadCrumbs_overflowWrapper__O0aFR","point":"breadCrumbs_point___AwGt","current":"breadCrumbs_current__uks0O","currentBf":"breadCrumbs_currentBf__aXcqk","active":"breadCrumbs_active__ExqTi","activeBf":"breadCrumbs_activeBf__8B_QV","crumb":"breadCrumbs_crumb__8cnCn","home":"breadCrumbs_home__ahfAn","homeBf":"breadCrumbs_homeBf__oorFp"};

/***/ }),

/***/ 27404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"CardNews_card__DevTb","large":"CardNews_large__2qGpG","wrapper":"CardNews_wrapper__jsg6A","linkPhoto":"CardNews_linkPhoto__pLz1x","content":"CardNews_content__X3LBq","description":"CardNews_description__QEUKP","text":"CardNews_text__MpUzR","info":"CardNews_info__n1iG9","mediaDate":"CardNews_mediaDate__Ic0er","date":"CardNews_date__Xek_S","readTime":"CardNews_readTime___fuFc"};

/***/ }),

/***/ 55828:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dots":"dots_dots__e0bPc","regularDots":"dots_regularDots__1Wi_S","active":"dots_active__dN4oS","longDots":"dots_longDots__Nb5eQ","dynamicWidth":"dots_dynamicWidth__pA3rZ"};

/***/ }),

/***/ 99407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"arrows_btn__MpugV","emblaButton":"arrows_emblaButton__jYhAy","emblaButtonPrev":"arrows_emblaButtonPrev__LLGM1","emblaButtonNext":"arrows_emblaButtonNext__c6yBu","lg":"arrows_lg__q8ytc"};

/***/ }),

/***/ 52851:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"image_root__lPXxH","none":"image_none__MXx4v","cover":"image_cover__iOpfP","fill":"image_fill__BMPWp","contain":"image_contain__tYnQv"};

/***/ }),

/***/ 51055:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"radioButton_radioGroup__lzV3s","radioGroupShort":"radioButton_radioGroupShort__OWEz5","radioGroupFilter":"radioButton_radioGroupFilter__sG55Z","radioButton":"radioButton_radioButton__F9HNL","radioButtonChecked":"radioButton_radioButtonChecked___2_9R","radioButtonDescription":"radioButton_radioButtonDescription___QphC","radioButtonFilter":"radioButton_radioButtonFilter__2iPp_","input":"radioButton_input__4NPeH","inputWrapper":"radioButton_inputWrapper__VuqQu","inputBlock":"radioButton_inputBlock___ewAe","gift":"radioButton_gift__ksS9S","labelTag":"radioButton_labelTag__2Xw4a"};

/***/ }),

/***/ 36701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Skeleton_card__UKdC1","selectCabin":"Skeleton_selectCabin__aFpe_"};

/***/ })

}]);